export default function Differences() {
  return (
    <section className="pt-16 pb-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Feature Row 1 - Horizontal Video */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center mb-40">
          <div className="space-y-4 md:space-y-6 px-4 md:px-0">
            <h3 className="text-xl md:text-2xl lg:text-3xl font-medium md:font-bold text-gray-900 leading-tight">
              振付があるから、迷わない。
            </h3>
            <p className="text-sm md:text-xl font-light text-gray-600 leading-[1.8] md:leading-relaxed">
              {/* モバイル用テキスト */}
              <span className="md:hidden">
                誰でもスタイルが立ち、<br />
                「それっぽく」見える<br />
                構造があります。
              </span>
              {/* デスクトップ用テキスト */}
              <span className="hidden md:inline">
                誰でもスタイルが立ち、「それっぽく」見える構造があります。
              </span>
            </p>
          </div>
          
          <div className="flex justify-center">
            <div className="w-full aspect-video rounded-3xl overflow-hidden shadow-2xl">
              <video
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover"
              >
                <source
                  src="https://video.bailabailamove.com/ito_dance2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
        
        {/* Feature Row 2 - Vertical Video */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="flex justify-center md:order-1">
            <div className="w-[60%] md:w-full md:max-w-sm max-h-[450px] md:max-h-[700px] aspect-[9/16] rounded-3xl overflow-hidden shadow-xl">
              <video
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover"
              >
                <source
                  src="https://video.bailabailamove.com/sakura3.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          
          <div className="space-y-4 md:space-y-6 px-4 md:px-0 md:order-2">
            <h3 className="text-xl md:text-2xl lg:text-3xl font-medium md:font-bold text-gray-900 leading-tight">
              入り口となる動きがある。
            </h3>
            <p className="text-sm md:text-xl font-light text-gray-600 leading-[1.8] md:leading-relaxed">
              {/* モバイル用テキスト */}
              <span className="md:hidden">
                シンプルなリズムスクワットから、<br />
                ダンスの世界へ。
              </span>
              {/* デスクトップ用テキスト */}
              <span className="hidden md:inline">
                シンプルなスクワットから、ダンスの世界へ。
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}